module.exports = __webpack_public_path__ + "public/images/slider/malafeeva-circle.7ac3e46205874380aafa037d17eb5208.png";